import React, { useEffect, useState } from 'react'
import { AiOutlinePlusCircle, AiOutlineDelete, AiOutlineEdit } from 'react-icons/ai';
import axios from 'axios';
import ToastNotification from '../../../components/ToastNotification';

const FollowupStatus = () => {

    const [showForm, setShowForm] = useState(false);
    const [followupStatusList, setFollowupStatusList] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [editId, setEditId] = useState(null);
     const [isEditMode, setIsEditMode] = useState(false);

    const [formData, setFromData] = useState({
        status: ""
    });

    const [toast, setToast] = useState({
        show: false,
        message: '',
        bg: 'success'
    });

    // ================= LOAD STATUS LIST =================
    const fetchStatusList = async () => {
        try {
            const res = await axios.get('https://api.skyguard.group/api/fetch-followup-status');
            setFollowupStatusList(res.data);
        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => {
        fetchStatusList();
    }, []);

    // ================= HANDLERS =================
    const handleFormOpen = () => {
        setShowForm(true);
        setEditId(null);
        setFromData({ status: "" });
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFromData(prev => ({ ...prev, [name]: value }));
    };

    const showToast = (message, bg = 'success') => {
        setToast({ show: true, message, bg });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const newStatus = formData.status.trim().toLowerCase();
        const isDuplicate = followupStatusList.some(
            item => item.status.toLowerCase() === newStatus && item.id !== editId
        );

        if (isDuplicate) {
            showToast('Duplicate FollowUp Status not allowed', 'warning');
            return;
        }

        try {
            if (isEditMode && editId) {
                // PUT
                await axios.put(`https://api.skyguard.group/api/update-followup-status/${editId}`, formData);
                showToast('FollowUp Updated Successfully', 'success');
            } else {
                // POST
                const res = await axios.post('https://api.skyguard.group/api/add-followup-status', formData);
                showToast('FollowUp Added Successfully', 'success');
                setFollowupStatusList(prev => [
                    ...prev,
                    { id: res.data.insertId, ...formData }
                ]);
            }

            setShowForm(false);
            setFromData({ status: "" });
            setEditId(null);
            fetchStatusList();

        } catch (err) {
            console.error(err);
            showToast('Error Adding', 'danger');
        }
    };


    // ================= EDIT =================
    const handleEdit = (row) => {
        setFromData({
            id:row.id || "",
            status:row.status || '',
        })
        setEditId(row.id);
         setIsEditMode(true);
        setShowForm(true);
    };

    // ================= SEARCH =================
    const filteredData = followupStatusList.filter(itm =>
        itm.status.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <>
            <div className='main-section'>
                <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
                    <h3 className='my-3 fw-bold fs-5 golos'>FollowUp Status</h3>

                    {/* Search & Add */}
                    <div className="mb-3 row gx-3 gy-2 align-items-center d-flex justify-content-between">
                        <div className="col-12 col-md-5">
                            <input
                                type="text"
                                className="form-control border-0 border-bottom border-dark"
                                placeholder="Search..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                required
                            />
                        </div>
                        <div className="col-12 col-md-2 d-flex justify-content-end">
                            <button className='btn btn-success' onClick={handleFormOpen}>
                                <AiOutlinePlusCircle size={20} /> Add
                            </button>
                        </div>
                    </div>

                    {/* FORM */}
                    {showForm && (
                        <div className='card p-3 my-3 shadow-sm bg-white border'>
                            <form onSubmit={handleSubmit}>
                                <div className="col-md-6">
                                    <label className="form-label fw-medium">
                                        {editId ? "Edit FollowUp Status" : "Add FollowUp Status"}
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="status"
                                        placeholder="Enter here..."
                                        value={formData.status}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                <div className='d-flex justify-content-end mt-4 gap-2'>
                                     <button type="submit" className='btn btn-success'>
                                        {isEditMode ? 'Update' : 'Save'} 
                                    </button>
                                    <button
                                        type='button'
                                        className='btn btn-danger'
                                     onClick={() => { setShowForm(false); setIsEditMode(false); setFromData({
                                        status:''
                                     }); }}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </form>
                        </div>
                    )}

                    {/* TABLE */}
                    <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
                        <table className='table table-bordered table-sm table-striped table-hover text-center align-middle'>
                            <thead className='table-info'>
                                <tr>
                                    <th>Sr No.</th>
                                         <th>Action</th>
                                    <th>FollowUp Name</th>
                                    <th>Created Date</th>
                               
                                </tr>
                            </thead>
                            <tbody>
                                {filteredData.map((row, idx) => (
                                    <tr key={row.idx}>
                                        <td>{idx + 1}</td>
                                           <td>
                                            <AiOutlineEdit
                                                size={22}
                                                className="text-primary me-2 cursor-pointer"
                                                onClick={() => handleEdit(row)}
                                            />
                                        </td>
                                        <td>{row.status}</td>
                                        <td>{new Date(row.created_at).toLocaleDateString()}</td>
                                     
                                    </tr>
                                ))}

                                {filteredData.length === 0 && (
                                    <tr>
                                        <td colSpan="4">No data found</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                </div>
            </div>

            <ToastNotification
                show={toast.show}
                message={toast.message}
                bg={toast.bg}
                onClose={() => setToast({ ...toast, show: false })}
            />
        </>
    );
};

export default FollowupStatus;
